import { runSecondFactorAction, type AskSecondFactor } from './run-second-factor-action';
import { useSecondFactorPrompt } from './second-factor-context';

export function useSecondFactorAction() {
  const { ask } = useSecondFactorPrompt();

  return {
    run: <T,>(options: Parameters<typeof runSecondFactorAction<T>>[1]) =>
      runSecondFactorAction<T>(ask as AskSecondFactor, options),
  };
}
